import React, { useCallback, useState } from 'react';
import getConfig from 'next/config';
import dynamic from 'next/dynamic';
import cx from 'classnames';

import Analytics from 'components/Layout/components/Analytics';
import Pseudolink from 'components/Pseudolink';
import DataLoader from 'components/DataLoader';
import OnlyClient from 'components/OnlyClient';

import styles from './styles.module.scss';

const Misprint = dynamic(
	() => import('components/Layout/components/Misprint'),
	{
		ssr: false
	}
);
const FaqContainer = dynamic(() => import('containers/Layout/Faq'), {
	ssr: false,
	loading: DataLoader
});

const { publicRuntimeConfig } = getConfig();

const Sidebar = () => {
	const [showFaq, setShowFaq] = useState(false);

	const toggleFaq = useCallback(() => setShowFaq(!showFaq), [showFaq]);

	return (
		<div className={styles.sidebar}>
			<div className={styles.block}>
				<div className={styles.element}>
					<div className={styles.contact}>
						<div className={styles.title}>Контакты</div>
						<div className={styles.list}>
							<div>
								E-mail:{' '}
								<a href="mailto:cultrf@mkrf.ru" className="link">
									cultrf@mkrf.ru
								</a>
							</div>
							<div>
								<Pseudolink
									title="Обратная связь"
									onClick={toggleFaq}
									tabIndex={0}
								/>
							</div>
							<div>Нашли опечатку? Ctrl+Enter</div>
						</div>
					</div>
				</div>
			</div>
			<div className={styles.block}>
				<div className={cx(styles.element, styles.policy)}>
					<div className={styles.policy}>
						При цитировании и копировании материалов с портала активная
						гиперссылка обязательна
					</div>
				</div>

				<div className={styles.element}>
					{publicRuntimeConfig.features.analytics && (
						<OnlyClient>
							<Analytics services={['yandex', 'pixel']} />
						</OnlyClient>
					)}
				</div>
			</div>
			<Misprint />
			{showFaq && <FaqContainer show={showFaq} onRequestClose={toggleFaq} />}
		</div>
	);
};

export default Sidebar;
